import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/browser';

import { useAppContext } from '../../hooks';

import PlacesSearchField from './PlacesSearchField';

function NameFormField({
  disabled,
  countryCode,
  onPlaceSelect,
  onPlaceDismiss,
}) {
  const { placesService } = useAppContext();
  const { values, errors, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (!values.facility_name && values.google_places_id) {
      placesService
        .getDetails({
          placeId: values.google_places_id,
          fields: ['name'],
        })
        .then((place) => {
          setFieldValue('facility_name', place.name);
        })
        .catch((error) => {
          Sentry.captureException(error);
          console.log(error);
        });
    }
  }, []); // eslint-disable-line

  return (
    <PlacesSearchField
      searchType="restaurant"
      countryCode={countryCode}
      name="facility_name"
      label={`${i18n.gettext('Restaurant name')} *`}
      error={errors.facility_name}
      value={values.facility_name}
      onChange={(value) => setFieldValue('facility_name', value)}
      onSelect={async (suggestion) => {
        const place = await placesService.getDetails({
          fields: ['place_id', 'name', 'address_components'],
          placeId: suggestion.place_id,
        });
        setFieldValue('facility_name', place.name);
        onPlaceSelect(place);
      }}
      onClear={onPlaceDismiss}
      getValue={(suggestion) =>
        suggestion.structured_formatting?.main_text || suggestion.description
      }
      disabled={disabled}
    />
  );
}

NameFormField.propTypes = {
  disabled: PropTypes.bool,
  countryCode: PropTypes.string,
  onPlaceSelect: PropTypes.func.isRequired,
  onPlaceDismiss: PropTypes.func,
};

export default NameFormField;
